import { inject, observer } from "mobx-react";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import TablePagination from "@material-ui/core/TablePagination";
import CreateQuickClip from "../components/CreateQuickClip";
import PlayFilters from "./PlayFilters";

export const styles = theme => ({
  root: {
    fontSize: theme.typography.pxToRem(12)
  },
  toolbar: {
    height: 56,
    minHeight: 56,
    paddingRight: 30,
    paddingTop: 8,
    marginBottom: 12,
    justifyContent: "space-between"
  }
});

class PlayPaginationBar extends React.Component {
  render() {
    const { videoSearchStore, classes, ...other } = this.props;
    return (
      <div className={classes.root} {...other}>
        <Toolbar className={classes.toolbar}>
          <PlayFilters />
          {videoSearchStore.plays.length > 0 && (
            <div style={{ display: "flex" }}>
              <CreateQuickClip />
              <TablePagination
                component="div"
                count={videoSearchStore.totalPlays}
                rowsPerPage={videoSearchStore.playsPerPage}
                page={videoSearchStore.page}
                rowsPerPageOptions={[10, 20, 30]}
                backIconButtonProps={{
                  "aria-label": "Previous Page"
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page"
                }}
                labelRowsPerPage="Plays per page:"
                onPageChange={(event, page) => {
                  videoSearchStore.setPage(page);
                }}
                onRowsPerPageChange={event => {
                  videoSearchStore.setPlaysPerPage(event.target.value);
                }}
              />
            </div>
          )}
        </Toolbar>
      </div>
    );
  }
}

export default inject("videoSearchStore")(
  withStyles(styles)(observer(PlayPaginationBar))
);



// WEBPACK FOOTER //
// ./src/containers/PlayPaginationBar.js